import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../css/PaymentError.css';

const PaymentError = () => {
  const location = useLocation();
  const [errorDetails, setErrorDetails] = useState({
    code: '',
    message: 'There was an issue processing your payment.'
  });
  
  useEffect(() => {
    // Try to get error details from URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const errorCode = queryParams.get('code');
    const errorMessage = queryParams.get('message');
    
    if (errorCode || errorMessage) {
      setErrorDetails({
        code: errorCode || 'UNKNOWN',
        message: errorMessage || 'There was an issue processing your payment.'
      });
    }
  }, [location]);

  return (
    <section className="payment-error-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mb-3 mb-md-0">
            <div className="position-stick-top">
              <h4>Payment Failed</h4>
              <div className="error-summary mb-4">
                <div className="error-icon">
                  <i className="fa fa-exclamation-circle"></i>
                </div>
                <p className="error-message">
                  {errorDetails.message}
                </p>
                {errorDetails.code && (
                  <div className="error-code">
                    Error Code: {errorDetails.code}
                  </div>
                )}
              </div>
              <Link to="/payment-instructions" className="btn1">
                Try Again
              </Link>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="content">
              <div className="instruction-card">
                <div className="card-header">
                  <i className="fa fa-info-circle"></i>
                  <h5>What to do next?</h5>
                </div>
                <div className="card-body">
                  <div className="help-options">
                    <div className="help-item">
                      <i className="fa fa-credit-card"></i>
                      <span>Verify your payment information</span>
                    </div>
                    <div className="help-item">
                      <i className="fa fa-wallet"></i>
                      <span>Check your account balance</span>
                    </div>
                    <div className="help-item">
                      <i className="fa fa-exchange-alt"></i>
                      <span>Try a different payment method</span>
                    </div>
                    <div className="help-item">
                      <i className="fa fa-headset"></i>
                      <span>Contact support for assistance</span>
                    </div>
                  </div>

                  <div className="contact-support">
                    <div className="support-item">
                      <i className="fa fa-envelope"></i>
                      <a href="mailto:support@confidentdriver.com">support@confidentdriver.com</a>
                    </div>
                    <div className="support-item">
                      <i className="fa fa-phone"></i>
                      <a href="tel:+19054598484">+1 905-459-8484</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/" className="btn btn-outline">Return Home</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentError; 